import React, { createContext, useState, useContext } from 'react';

const ErrorContext = createContext(null);
function ErrorProvider({ children }) {
    const [error, setError] = useState(null);
    return React.createElement(ErrorContext.Provider, { value: { error, setError } }, children);
}
function useError() {
    return useContext(ErrorContext);
}

export { ErrorProvider, useError };
